import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../assets/css/add-new-question.css";
import { Redirect } from 'react-router';
import Header from "./Header";
import Menu from "./Menu";
import { CONFIG, URLS } from "../helpers/Common";

class PatientResponse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patient_additional_info: "",
      prevStep: 5,
      profileData: new Array(),
      redirect: false
    };
    this.handleAction = this.handleAction.bind(this);
    this.setAddionalInfo = this.setAddionalInfo.bind(this);
  }

  componentWillMount() {
    this.setState({
      profileData: this.props.getProfileData
    });
    
  }
  handleAction = e => {
    let profileData = this.state.profileData;
    profileData.patient_additional_info = this.state.patient_additional_info;

    localStorage.setItem('patientProfile',  JSON.stringify(profileData));
    let data = JSON.parse(localStorage.getItem('data'));
    let complainData = this.props.getComplainData.complainTypeDetails;
    let saveData = new Array();
    let complainLocationData = this.props.getComplainLocationData;
    saveData = {
      title: profileData.title,
      first_name: profileData.first_name,
      last_name: profileData.last_name,
      email: profileData.email,
      phone: profileData.phone,
      gender: profileData.gender,
      narrative_summary: profileData.narrative_summary,
      dob: profileData.dob,
      patient_additional_info: this.state.patient_additional_info,
      answers:data
    };
    localStorage.setItem("data",JSON.stringify(saveData));
    
    this.setState({
      redirect:true
    })
  };

  setAddionalInfo = e => {
    this.setState({
      patient_additional_info: e.target.value
    });
  };

  
  render() {
    if (this.state.redirect) {
      return <Redirect push to="/thankyou" />;
    }
    return (
      <React.Fragment>
        <Header
          title="Patient Narrative Response"
          titleImage="ic-medical-result.png"
        />
        <Menu />
        <section className="sec--question add-new-question">
          <form>
            <div className="question-form">
              <div className="container">
                <div className="row">
                  <div className="col-md-1 col-sm-1" />
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="form-group">
                      <label htmlFor="txt">Add Any Additional Info</label>
                      <textarea
                        id="txt"
                        className="form-control"
                        onChange={this.setAddionalInfo}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
        <div className="sec-btn patient--btn">
          <Link to="#" className="btn-img" onClick={this.handleAction}>
            <img
              src={require("../assets/img/icons/ic-incomplete-native.png")}
              alt=""
            />
            <span>Skip</span>
          </Link>
          <Link to="#" className="btn-img" onClick={this.handleAction}>
            <img
              src={require("../assets/img/icons/ic-complete-native.png")}
              alt=""
            />
            <span>Save</span>
          </Link>
        </div>
      </React.Fragment>
    );
  }
}

export default PatientResponse;
